import React from 'react';

/** What an empty surface says. Never an illustration, never encouragement. */
export function EmptyState({ line, detail, style }) {
  return (
    <div style={{ padding: 'var(--bujo-space-3) 0', ...style }}>
      <div style={{
        font: 'var(--bujo-fw-regular) var(--bujo-fs-body)/var(--bujo-lh-row) var(--bujo-font-mono)',
        color: 'var(--bujo-text-dim)'
      }}>{line}</div>
      {detail ? (
        <div style={{
          marginTop: 'var(--bujo-space-1)',
          font: 'var(--bujo-fw-regular) 11.5px/var(--bujo-lh-row) var(--bujo-font-sans)',
          color: 'var(--bujo-text-meta)'
        }}>{detail}</div>
      ) : null}
    </div>
  );
}
